<div [ngClass]="styleClass" class="scrolled-list">
    <div class="items-container">
        <ng-container>
            <ng-container *ngFor="let item of visibleItems;let i = index;">
                <div class="item noselect"
                    [ngStyle]="{'height.px': itemHeight, 'top.px' : ( i * itemHeight - parentMarginTop )}">
                    <!-- jak nie scrolluje -->
                    <ng-container [ngTemplateOutlet]="itemTemp"
                        [ngTemplateOutletContext]="{ $implicit: item , idx : (i + currentStartIndex) }"></ng-container>
                </div>
            </ng-container>
        </ng-container>
    </div>
</div>